const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'AePie',
  props: {
    data: {
      type: Array,
      default: () => [
        { name: '栏目一', value: '20' },
        { name: '栏目二', value: '60' },
        { name: '栏目三', value: '30' },
        { name: '栏目四', value: '50' },
        { name: '栏目五', value: '80' },
        { name: '栏目六', value: '10' },
        { name: '栏目七', value: '15' },
        { name: '栏目八', value: '25' },
      ]
    },
    title: { type: String, default: () => '' },
    name: { type: String, default: () => '' },
    type: { type: String, default: () => 'pie' },
    radius: { type: Array, default: () => ['30%', '60%'] },
    roseType: { type: String, default: () => '' }, // radius
    fontSize: { type: String, default: () => '12' },
    showLegend: { type: Boolean, default: () => true },
    backgroundColor: { type: String, default: () => '' },
  },
  data() {
    return {
      option: {},
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.create();
      }
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const series = [
        {
          name: this.name,
          type: this.type,
          radius: this.radius,
          roseType: this.roseType,
          center: ['50%', '50%'],
          data: this.data.length > 0 && this.data.map((a, b) => ({
            selected: false,
            label: {},
            labelLine: {
              smooth: 0.2,
              length: 10,
              length2: 20,
            },
            itemStyle: {
              normal: {
                color: a.color,
                shadowBlur: 200,
                shadowColor: 'rgba(0, 0, 0, 0.4)',
                shadowOffsetX: -4,
                shadowOffsetY: 4,
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              }
            },
            animationDelay: c => c * b * 100,
            name: a.text || a.label || a.title,
            ...a,
          })).sort((a, b) => (a.value - b.value)),
          animationType: 'scale',
          animationEasing: 'elasticOut',
          animationDelay: () => Math.random() * 200,
        },
      ];
      this.option = {
        backgroundColor: this.backgroundColor,
        title: {
          text: this.title,
          textStyle: {
            fontSize: (this.fontSize * 1.2),
            color: 'rgba(255, 255, 255, 0.9)',
            align: 'center',
          }
        },
        tooltip: {
          trigger: 'item'
        },
        grid: {
          top: this.showLegend ? (this.fontSize * 3) : 0,
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true,
          textStyle: {
            fontSize: this.fontSize,
          },
        },
        legend: {
          show: this.showLegend,
          left: 'center',
        },
        series,
      };
    },
  },
  render() {
    const { option = {}, delay = 400, ...attrs } = this.$attrs;
    return (<Aecharts option={{ ...this.option, ...option }} delay={delay} {...{ attrs }} />);
  }
}